import { Button, Row, Col, Typography, Image, InputNumber, Form } from 'antd'
import crossIcon from '@/assets/svg/cross-icon.svg'

const { Title } = Typography

export default (props: any) => {
  const { onClose, title, value, handleChange, valueSelected, qtyError } = props

  return (
    <Form>
      <Row justify="space-between" align="middle" gutter={[10, 10]}>
        <Col>
          <Title level={4} className="mb-0">
            {title}
          </Title>
        </Col>
        <Col>
          <Button size="large" type="link" className="close_popup" onClick={onClose}>
            <Image src={crossIcon} preview={false} width={48} />
          </Button>
        </Col>
        <Col span={24} className="gutter-row">
          {console.log('value', value)}
          <InputNumber
            onChange={handleChange}
            className="line_qty"
            value={value}
            controls={false}
            status={qtyError ? 'error' : ''}
          />
          {qtyError && <div className="error_field">Quantity is required.</div>}
        </Col>
        <Col span={24}>
          <Row justify="center" gutter={[10, 10]}>
            <Col>
              <Button
                htmlType="submit"
                className="font-gilroy"
                type="primary"
                size="large"
                onClick={valueSelected}
              >
                Done
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  )
}
